var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStocking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.109 302.875C304.109 340.375 285.478 375.25 254.218 396.125L172.316 450.625C118.673 486.375 72.533 445 61.404 428.375C36.896 391.625 46.775 342 83.662 317.375L144.056 277.25V128H96.041V251.5L57.027 277.5C-1.741 316.75 -17.747 396.25 21.517 455C46.275 492 86.787 512 128.175 512C152.56 512 177.318 505 199.074 490.5L280.851 436C325.367 406.25 352 356.5 352 302.875V128H304.109V302.875ZM351.988 0H96.011C78.406 0 64 14.4 64 32V64C64 81.6 78.406 96 96.011 96H351.988C369.593 96 384 81.6 384 64V32C384 14.4 369.593 0 351.988 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocking);
export default __webpack_public_path__ + "static/media/stocking.897c1eea1fc4a698921680f2697c643b.svg";
export { ForwardRef as ReactComponent };